import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoaderService } from '../../../../common/loader/loader.service';
import { ReservationSummaryApiService } from '../../services/reservation-summary-api.service';
import { ReservationSummaryStoreService } from '../../services/reservation-summary-store.service';
import { InfoboxService } from '../../../../common/infobox/infobox.service';
import { filter, Subscription } from 'rxjs';
import { Reservation } from '../../../reservation.model';
import { TypeValueFactoryService } from '../../../../common/type-value-factory.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-reservation-summary-invoice-dialog',
	templateUrl: './reservation-summary-invoice-dialog.component.html',
	styleUrls: ['./reservation-summary-invoice-dialog.component.scss'],
})
export class ReservationSummaryInvoiceDialogComponent implements OnInit, OnDestroy {
	constructor(
		private readonly loader: LoaderService,
		private readonly apiService: ReservationSummaryApiService,
		private readonly store: ReservationSummaryStoreService,
		private readonly infobox: InfoboxService,
		private readonly dialogRef: MatDialogRef<ReservationSummaryInvoiceDialogComponent>,
	) {}

	subscription: Subscription;
	reservation: Reservation = TypeValueFactoryService.createReservationObject();

	ownerNip = '';
	invoiceNumber = '';

	ngOnInit(): void {
		this.store
			.getters()
			.reservation()
			.pipe(filter((reservation) => !!reservation))
			.subscribe((reservation) => {
				this.reservation = reservation;
				this.ownerNip = this.reservation.ownerNip;
				this.invoiceNumber = this.reservation.invoiceNumber;
			});
	}

	ngOnDestroy() {
		this.subscription?.unsubscribe();
	}

	closeDialog() {
		this.dialogRef.close();
	}

	submit() {
		this.loader.show('invoice-details-change');
		this.apiService
			.actions()
			.patchReservation({
				id: this.reservation.id,
				ownerNip: this.ownerNip,
				invoiceNumber: this.invoiceNumber,
			})
			.then(() => {
				this.infobox.success('Pomyślnie zmieniono dane fakturowania!');
			})
			.finally(() => {
				this.loader.hide('invoice-details-change');
				this.apiService.actions().getReservation(this.reservation.id);
				this.closeDialog();
			});
	}
}
